import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Fab, Tooltip } from '@mui/material';
import { QrCodeScanner } from '@mui/icons-material';
import { t } from 'i18next';
import Data from "../Data/.json"
import GetCookie from '../Services/GetCookie';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ContactQr() {
  const [open, setOpen] = React.useState(false);

  const cookieMode = GetCookie(Data.mode);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="Mon contact">
        <Fab onClick={handleClickOpen} style={{ position: 'fixed', bottom: 50, right: 20, backgroundColor: "#0cc0df" }}>
          <QrCodeScanner style={{ color: "white" }} />
        </Fab>
      </Tooltip>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className='boxQrContact' style={{ backgroundColor: (cookieMode === "dark")? "#032025": (cookieMode === "light")? "white" : "inherit", color: (cookieMode === "dark")? "white": (cookieMode === "light")? "black" : "inherit" }}>
          <center>
            <DialogTitle>{t("contact")}</DialogTitle>
            <img style={{borderRadius: "10px"}} width={"50%"} src={require("../Files/ConatctQr.png")} alt="" />
            <DialogTitle style={{ fontSize: "smaller", fontWeight: "lighter" }}>{t("contact-sous-titre")}</DialogTitle>
            {/* <br />
            <Button onClick={() => { window.open(env.DOWNLOAD_CONTACT_LINK) }} startIcon={<Download />} >{t("telecharger")}</Button> */}
          </center>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}